// docs/specs/login-setup.md §4: the rows of "Sign-in method order", pure so the hook and the section stay thin.
export const METHODS = ["email", "sms", "totp"];
export const LABELS = { email: "Email", sms: "Text message", totp: "Authenticator app" };
const SKIPPED = "Not set up — skipped at sign-in";

// Swaps the row at `index` with its neighbour `delta` away; past either end the same list comes back.
export const move = (list, index, delta) => {
  const to = index + delta;
  if (to < 0 || to >= list.length) return list;
  const next = [...list];
  [next[index], next[to]] = [next[to], next[index]];
  return next;
};

// Oracle stores all three, but a short or odd list must still render every method exactly once.
export const orderFrom = (priority) => {
  const known = (Array.isArray(priority) ? priority : []).filter((m, i, all) => METHODS.includes(m) && all.indexOf(m) === i);
  return [...known, ...METHODS.filter((m) => !known.includes(m))];
};

const detailFor = (method, prefs) => {
  if (!prefs?.available?.includes(method)) return SKIPPED;
  if (method === "email") return prefs.email_masked || "";
  if (method === "sms") return `${prefs.phone_masked || ""} · ${prefs.phone_verified ? "Verified" : "Not verified"}`;
  return prefs.totp_active ? "Set up" : "Not set up";
};

export const rowsFrom = (prefs, order = orderFrom(prefs?.priority)) =>
  order.map((method) => ({ method, label: LABELS[method], detail: detailFor(method, prefs) }));
